export function lessonsPath(filters) {
  const { subject, topic } = filters;
  if (!subject) return "/aulas";
  if (!topic) return `/aulas?disciplina=${subject.slug}`;
  return `/aulas?disciplina=${subject.slug}&topico=${topic.slug}`;
}
